export default __webpack_public_path__ + "static/media/Wolf's Helm of the Howling Moon.e425be8e.jpg";